import CommentSection from "@/components/Comments/CommentSection";
import PollCardWrapper from "@/components/Polls/PollCardWrapper";
import StatsSection from "@/components/Stats/StatsSection";
import { Tabs as LayoutTabs } from "@/components/Tabs";
import MainLayout from "@/lib/layout/MainLayout";
import { getPollMetadata } from "@/lib/server-functions/get-poll-metadata";
import { usePoll } from "@/lib/tanstack-query/hooks/usePoll";
import { seo } from "@/utils/seo";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

export const Route = createFileRoute("/_dashboard/poll/$shortId/$slug")({
  component: RouteComponent,
  loader: async ({ params }) => {
    const pollData = await getPollMetadata({ data: params });
    return { pollData };
  },
  head: ({ loaderData }) => ({
    meta: [...seo({ title: loaderData?.pollData?.question })],
  }),
});

function RouteComponent() {
  const { shortId, slug } = Route.useParams();
  const { data: poll } = usePoll(shortId, slug);
  const [activeTab, setActiveTab] = useState<"comments" | "stats">("comments");

  return (
    <>
      {poll && (
        <>
          <MainLayout.Content divider={true} hasPadding={false}>
            <PollCardWrapper polls={[poll]} />
          </MainLayout.Content>
          <MainLayout.Sticky>
            <LayoutTabs
              tabs={[
                { value: "comments", label: "Comments" },
                { value: "stats", label: "Statistics" },
              ]}
              activeTab={activeTab}
              onChange={setActiveTab}
            />
          </MainLayout.Sticky>
          <MainLayout.Content divider={false}>
            {activeTab === "comments" ? (
              <CommentSection pollId={poll.id} />
            ) : (
              <StatsSection optionIds={poll.options.map((o) => o.id)} />
            )}
          </MainLayout.Content>
        </>
      )}
    </>
  );
}
